// После АБ теста - удалить, а также ABAnimationAva и ABAnimationModal, а также npm react-confetti

import { useClickOutside } from "@hook";
import { sendMetric, getWhatId, pluralForm, randomNumber, getNearValues } from "@utils";

import { inject, observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";

import Confetti from "react-confetti";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const AnimationFortune = inject("mainStore")(
    observer(({ mainStore }) => {
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const offersList = mainStore.getMainStore("offersList");
        const settingLego = mainStore.getMainStore("settingLego");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");

        const { offers } = offersList;
        const nodeRef = useRef();

        const [seconds, setSeconds] = useState(settingLego.queueDuration || 5);
        const [prizes, setPrizes] = useState([]);

        const numberOffer = offers?.length || 8;
        const what_id = getWhatId() || VITE_WHAT_ID;
        const isTimeUp = !seconds;

        useClickOutside("fortune", nodeRef, !isTimeUp ? () => {} : () => handleClick());

        useEffect(() => {
            const randomPrizes =
                settingLego?.queueRandomness === false ? [...getNearValues(numberOffer, 16), ...getNearValues(numberOffer - 1, 1)] : [...Array.from({ length: 16 }, () => randomNumber(1, numberOffer)), numberOffer, randomNumber(1, numberOffer)];
            setPrizes(randomPrizes);

            const interval = setInterval(() => {
                setSeconds((prev) => {
                    if (prev === 1) {
                        clearInterval(interval);

                        sendMetric(`show_wheel`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: null,
                            params3: null,
                            params4: null,
                            params6: null,
                            params7: wdCd ? wdCd : null,
                            params8: what_id,
                        });

                        if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                            window.risMetrika.reachgoal_ch({
                                event: "widget_step_2_show",
                                siteId: what_id, //'id витрины',
                                session_uuid: localStorage.getItem("_r_p_s"),
                                widget_code: wdCd ? wdCd : "",
                            });
                        }

                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }, []);

        const handleClick = (isMetrika = false) => {
            if (isMetrika) {
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_2_click",
                        siteId: what_id,
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }
                sendMetric(`click_wheel_ok`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd ? wdCd : null,
                    params8: what_id,
                });
            }
            mainStore.setMainStore("isStart", false);
            mainStore.setMainStore("isCoverRoot", false);
            mainStore.setMainStore("modal", false);
        };

        const ctaColor = settingLego?.ctaColor === "palette" ? "var(--color7)" : "#19b677";

        return (
            <div className="animation-fortune" style={{ "--ctaColor": ctaColor, "--duration": (settingLego.queueDuration || 5) + "s" }}>
                <span className="animation-fortune__title">{isTimeUp ? "Ура! 🎁" : "Еще чуть-чуть! 🎁"}</span>
                {isTimeUp ? (
                    <span className="animation-fortune__sub" ref={nodeRef}>
                        У вас есть <b>5 минут</b> на выбор
                    </span>
                ) : (
                    <span className="animation-fortune__sub">Определяем количество подарков</span>
                )}
                <div className="animation-fortune__gifts-wrapper">
                    <div className="animation-fortune__nums">
                        {prizes.map((i, idx) => (
                            <div key={idx} className={`animation-fortune__num ${isTimeUp && idx === 16 ? "animation-fortune__num_active" : ""}`}>
                                {i}
                            </div>
                        ))}
                    </div>
                    <div className="animation-fortune__center" />
                </div>

                <div className="animation-fortune__bottom">
                    {isTimeUp ? (
                        <div className="animation-fortune__btn animation-fortune__btn_active" ref={nodeRef} onClick={() => handleClick(true)}>
                            Выбрать подарок
                        </div>
                    ) : (
                        <div className="animation-fortune__btn">
                            <span className="animation-fortune__btn-text">
                                Подарки будут доступны через {seconds} секунд{pluralForm(seconds, ["у", "ы", ""])}
                            </span>
                            <div className="animation-fortune__progress" />
                        </div>
                    )}
                </div>

                {isTimeUp && <Confetti className="animation-fortune__confetti" />}
            </div>
        );
    }),
);

export default AnimationFortune;
